export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'shortenName',
    sortField: 'shortenName',
    label: 'field.service',
    stickyColumn: true,
    variant: 'light',
  },
  // {
  //   key: 'departmentName',
  //   sortField: 'departmentName',
  //   label: 'field.department',
  //   variant: 'light',
  // },
  // {
  //   key: 'projectName',
  //   sortField: 'projectName',
  //   label: 'field.projectName',
  //   variant: 'light',
  // },
  {
    key: 'status',
    sortField: 'status',
    label: 'field.status',
    variant: 'light',
  },
  {
    key: 'operator',
    label: 'field.operator',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
  // {
  //   key: 'createdAt',
  //   sortable: true,
  //   sortField: 'createdAt',
  //   label: 'field.createDate',
  // },
]
